import Vue from 'vue';

import Clickoutside from '@/shared/lib/directives/click-outside';

Vue.directive('clickoutside', Clickoutside);
